export default __webpack_public_path__ + "static/media/sharpsans-medium.33d05241.otf";